<template>
  <div>
    <el-table
      :data="data"
      style="width: 100%"
      size="medium"
      header-row-class-name="supervision-table-header"
      :span-method="objectSpanMethod"
      tooltip-effect="light"
      row-class-name="common-table-row"
      class="is-print-hide common-table"
      border
    >
      <el-table-column label="通用名" prop="drugName"></el-table-column>
      <el-table-column label="规格" prop="drugSpec"></el-table-column>
      <el-table-column label="数量" prop="drugNum">
        <template #default="{ row: { drugNum, drugUnit } }">
          <span>{{ `${drugNum || ''}${drugUnit || ''}` }}</span>
        </template>
      </el-table-column>

      <el-table-column label="生产厂家" prop="drugManufacturer"></el-table-column>
      <el-table-column label="条形码" prop="barCode"></el-table-column>
      <el-table-column label="批准文号" prop="approvalNumber"></el-table-column>
      <el-table-column label="生产批号" prop="drugProductBatchNo"></el-table-column>
      <el-table-column label="分类" :min-width="100">
        <template #default="{ row: { drugVariety } }">
          {{ drugVariety | adaptDrugVariety }}
        </template>
      </el-table-column>
      <el-table-column label="是否处方药" :min-width="100">
        <template #default="{ row: { isPrescription } }">
          {{ isPrescription | formatPrescription }}
        </template>
      </el-table-column>
      <el-table-column label="有效期至" :min-width="100">
        <template #default="{ row: { drugValidityPeriod } }">
          {{ drugValidityPeriod | formatDate }}
        </template>
      </el-table-column>
      <el-table-column label="入库时间" width="160px">
        <template #default="{ row: { purchaseTime } }">
          {{ purchaseTime | formatTime }}
        </template>
      </el-table-column>
      <el-table-column label="入库单号" prop="purchaseId" width="120px"></el-table-column>
      <el-table-column label="供应商详情" prop="supplierName" width="120px">
        <template #default="{ row }">
          <el-button
            type="text"
            @click="
              gridTableData = [row];
              dialogTableVisible = true;
            "
          >
            查看
          </el-button>
        </template>
      </el-table-column>

      <el-table-column label="入库凭证" prop="orderId" :min-width="180" fixed="right">
        <template #default="{ row: { certificate, purchaseId } }">
          <el-button type="text" v-if="certificate && certificate.length" @click="viewImages(certificate)">
            查看
          </el-button>
          <el-button
            type="text"
            v-if="!certificate || certificate.length < 5"
            @click="handleUpload({ certificate, purchaseId })"
          >
            上传
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="供应商详情"
      :visible.sync="dialogTableVisible"
      center
      tooltip-effect="light"
      width="880px"
      alignFooter="right"
    >
      <div style="padding-bottom: 40px">
        <el-table :data="gridTableData" border>
          <el-table-column property="supplierName" width="160px" label="供应商名称"></el-table-column>
          <el-table-column property="supplierCreditCode" width="160px" label="统一组织机构代码证号"></el-table-column>
          <el-table-column
            property="supplierDrugLicense"
            width="200px"
            label="供应商药品经营许可证编号"
          ></el-table-column>
          <el-table-column property="supplierBusinessScope" width="190px" label="供应商经营范围"></el-table-column>
          <el-table-column property="supplierLegalPerson" width="120px" label="供应商法人"></el-table-column>
          <el-table-column property="supplierAddress" width="160px" label="供应商地址"></el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <Upload ref="upload" @submit="submit" :limit="limit" />
    <image-viewer :z-index="2000" :initial-index="0" v-if="dialogVisible" :on-close="closeViewer" :url-list="imgUrls" />
  </div>
</template>

<script>
import dayjs from 'dayjs';
import Upload from './upload.vue';
import imageViewer from '@/components/image-viewer';

export default {
  name: 'supervisionList',
  components: {
    Upload,
    imageViewer
  },
  props: {
    type: {
      type: String
    },
    data: {
      type: Array,
      default: () => []
    },
    spanArr: {
      type: Array,
      default: () => []
    },
    storeId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      gridTableData: [],
      dialogTableVisible: false,
      limit: 0,
      dialogVisible: false,
      imgUrls: [],
      showViewer: false,
      purchaseId: ''
    };
  },
  methods: {
    async submit(fileIds) {
      await Fetch.pc_inventory_supervision_laid_up_upload({ purchaseId: this.purchaseId, fileIds }).then(res => {
        this.$emit('renderTable');
        this.$refs.upload.dialogVisible = false;
      });
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 12) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        console.log(`rowspan:${_row} colspan:${_col}`);
        return {
          rowspan: _row,
          colspan: _col
        };
      }
    },
    handleUpload(item) {
      this.limit = 5 - item?.certificate?.length;
      this.purchaseId = item?.purchaseId;
      this.$refs.upload.dialogVisible = true;
    },
    viewImages(certificate) {
      this.dialogVisible = true;
      this.imgUrls = certificate;
    },
    closeViewer() {
      this.dialogVisible = false;
    }
  },
  filters: {
    formatTime(val) {
      if (!val) return '--';
      return dayjs(val).format('YYYY-MM-DD HH:mm:ss');
    },
    formatPrescription(val) {
      return val === 1 ? '处方药' : val === 0 ? '非处方药' : '--';
    },
    formatDate(val) {
      if (!val) return '--';
      return dayjs(val).format('YYYY-MM-DD');
    },
    adaptDrugVariety(val) {
      const statusMap = {
        YBYP: '一般药品',
        BJSP: '食品保健品',
        ZYYP: '中药饮片',
        ZYC: '中药材',
        YLQX: '医疗器械',
        YYHC: '医用耗材',
        QT: '其他'
      };
      return statusMap[val];
    },
    adaptPatchStatus(val) {
      const statusMap = { 1: '已上传', 0: '未上传' };
      return statusMap[val];
    }
  }
};
</script>

<style lang="scss" scoped>
.drug-item {
  position: relative;
  padding: 5px 0;

  .drug-title {
    font-weight: 500;
  }

  &:before {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 1px;
    background-color: #efefef;
  }

  &:last-child {
    &:before {
      display: none;
    }
  }
}

.red {
  color: #eb3c36;
}

.green {
  color: #1e8dff;
}

.yellow {
  color: #ebb436;
}
</style>
